"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScoreOutputIndex = exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var GAMBLING = "GAMBLING";
var questions = [{
  prompt: "First question: Gambling is any of these activities. Please choose any that you’ve done in the last year",
  type: "multiWithOther",
  options: ["Lottery tickets", "Gambling at a casino", "Playing cards or dice for money", "Betting on sports games", "Playing slot machines, video poker or other video gambling", "Gambling on the internet or via an app", "Betting on horses or dogs, playing bingo or keno", "Other"],
  batteryId: GAMBLING,
  meta: {
    answerLabel: "I gamble via",
    customResponse: true,
    responsePrefix: "My gambling acitvities are: ",
    summaryTitle: "Gambling is any of these activities. Please choose any that you’ve done in the last year"
  }
}, {
  prompt: "During the past year have you gambled 5 or more times on any of those activities?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year have you gambled 5 or more times on any of those activities?"
  }
}, {
  prompt: "During the past year, have you ever felt restless, on edge or irritable when trying to stop or cut down on gambling?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, have you ever felt restless, on edge or irritable when trying to stop or cut down on gambling?"
  }
}, {
  prompt: "During the past year, Have you had to ask other people for money to help deal with financial problems that had been caused by gambling?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Have you had to ask other people for money to help deal with financial problems that had been caused by gambling?"
  }
}, {
  prompt: "During the past year, Have you tried to hide how much you have gambled from your family or friends?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Have you tried to hide how much you have gambled from your family or friends?"
  }
}, {
  prompt: "During the past year, Have you tried to cut down or stop your gambling?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Have you tried to cut down or stop your gambling?"
  }
}, {
  prompt: "During the past year, Have you increased your bet or how much you would spend, in order to feel the same kind of excitement as before?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Have you increased your bet or how much you would spend, in order to feel the same kind of excitement as before?"
  }
}, {
  prompt: "During the past year, Did you think about gambling even when you were not doing it? (Remembering past gambling experiences, or planning future gambling?)",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Did you think about gambling even when you were not doing it? (Remembering past gambling experiences, or planning future gambling?)"
  }
}, {
  prompt: "During the past year, Did you go to gamble when you were feeling down, stressed, angry or bored?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Did you go to gamble when you were feeling down, stressed, angry or bored?"
  }
}, {
  prompt: "During the past year, Did you ever try to win back the money that you had recently lost?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Did you ever try to win back the money that you had recently lost?"
  }
}, {
  prompt: "During the past year, Has your gambling caused problems in your relationships or with work?",
  type: "radio",
  options: ["No", "Yes"],
  pointScale: [0, 1],
  batteryId: GAMBLING,
  meta: {
    summaryTitle: "During the past year, Has your gambling caused problems in your relationships or with work?"
  }
}];
exports.questions = questions;

var getScoreOutputIndex = function getScoreOutputIndex(score) {
  if (score === 0) {
    return 0;
  } else if (score >= 1 && score <= 2) {
    return 1;
  } else if (score >= 3 && score <= 4) {
    return 2;
  } else if (score >= 6) {
    return 3;
  }
};

exports.getScoreOutputIndex = getScoreOutputIndex;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    var _answers$question$bat;

    if (!question.hideFromSummary && (_answers$question$bat = answers[question.batteryId][index]) !== null && _answers$question$bat !== void 0 && _answers$question$bat.toString()) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index].join(", ")
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;